import React, { useState, useEffect, useRef } from 'react';
import {useSpring, animated } from 'react-spring'
import styled from 'styled-components';

import  {CloseButton, ResizeButton}  from "../Config/generalButton.js"

import resizeExpandIcon from "../images/icon/resizeExpandIcon.png"
import resizeShrinkIcon from "../images/icon/resizeShrinkIcon.png"

import {overview,
        plan, 
        marker, 
        pieRange, 
        markerPath1Config, 
        mapBtnPath1Config,
        markerPath2Config, 
        mapBtnPath2Config,
      } from "../Config/mapConfig"

//path shift
//const [ markerConfig, mapBtnConfig ]=[ markerPath1Config, mapBtnPath1Config ]
const [ markerConfig, mapBtnConfig ]=[ markerPath2Config, mapBtnPath2Config ]

const MapOuter = styled(animated.div)`
  //width height用useSpring設的
  position: absolute;
  left:2%;
  top:138px;
  z-index:300;
  &::-webkit-scrollbar-track{
    border-radius: 3px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar{
    height:3vw;
    max-height:12px;
    width:3vw;
    max-width: 12px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb{
    border-radius: 3px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #555;
  }
  &::-webkit-scrollbar-corner { background: #F5F5F5; }
`

const MapPlanWrapper = styled.div`
    cursor:'pointer';
    position:relative;
    width:96vw;
    height:42.5vw;
    background-size: 100% 100%;
  }
`

const PlanMarkerWrapper = styled.div`
    position:absolute;
    width:2vw;
    min-width:10px;
    max-width:20px;
    height:2vw;
    min-height:10px;
    max-height:20px;
`

const PlanMarker = styled.img`
  cursor:'pointer';
  width: 100%;
  height: auto;
  top:0%;
  left:0%;
  border: none;
  position: relative;
  &:hover{
    filter: invert(100%);
    transform: scale(1.5, 1.5);
  };
  z-index:26;
`

const PlanPieRange = styled.img`
  position: relative;
  width: 150%;
  height: auto;
  top:-200%;
  left:-20%;
  border: none;
  filter: opacity(50%);
  transform-origin: 50% 100%;
`

const OverviewBtn = styled.img`
  position:absolute;
  height:5%;
  min-height:15px;
  width:auto;
  transform-origin: 50% 50%;
  &:hover{
    transform: scale(1.3, 1.3);
  };
`

const MapPlan=( props )=>{
    
  const{ planMode, setPlanMode, imgIndex, setImgIndex, setGoToYaw, setGoToPitch, nowYaw, langCh } = props
  
  const [ scrollXY, setScrollXY ]=useState([0,0])//for ios sticky

  const mapPlanRef = useRef(null)

  const [ mapPlanProps, setMapPlanProps ] = useSpring(()=>({ width:'0vw',height:'0vw',overflow:'hidden'}) )

  const closeHandler=()=>{setPlanMode('')}

  //plan image size: 3000*1330
  useEffect(()=>{
    if (planMode === 'med'){
      setMapPlanProps({ width:'30vw',height:'13.3vw',overflow:'scroll'})

    }else if(planMode === 'large'){
      setMapPlanProps({ width:'96vw',height:'42.5vw',overflow:'hidden'})
    }else{
      setMapPlanProps({ width:'0vw',height:'0vw',overflow:'hidden'})
    }
  },[ planMode ])

  useEffect(() => {
    let offSetTop=parseInt(markerConfig[imgIndex].top)/100;
    let offSetLeft=parseInt(markerConfig[imgIndex].left)/100;
    mapPlanRef.current.scrollTop=mapPlanRef.current.scrollHeight*offSetTop-mapPlanRef.current.clientHeight*0.5;
    mapPlanRef.current.scrollLeft=mapPlanRef.current.scrollWidth*offSetLeft-mapPlanRef.current.clientWidth*0.5;
  }, [ imgIndex, planMode ])

  return(
      <MapOuter 
        //minWidth, minHeight for mobile device
        style={{...mapPlanProps,minWidth:planMode==='med'?'300px':null,minHeight:planMode==='med'?'150px':null}} 
        ref ={mapPlanRef}
        onScroll={()=>{ setScrollXY([ mapPlanRef.current.scrollTop,
                                      mapPlanRef.current.scrollLeft ] )
                        //console.log('13')
                  }}
      >
          <MapPlanWrapper     style={{backgroundImage: `url(${plan})`}} >
              {markerConfig.map((data,i)=>{//console.log(imageGalleryRef.current.state.currentIndex,i)
                                          return( <PlanMarkerWrapper 
                                                    style={{top:data.top,left:data.left}} 
                                                    key={i}
                                                    onClick={()=>{
                                                                  setGoToYaw(data.args[1])
                                                                  setGoToPitch(data.args[2])
                                                                  setImgIndex(data.args[0])
                                                                }}
                                                  >
                                                      <PlanMarker  
                                                          src={marker} 
                                                          style={{filter:imgIndex === i ? 'opacity(100%) saturate(1)':'opacity(50%) saturate(0)'}}
                                                      /> 
                                                      <PlanPieRange  
                                                        src={pieRange} 
                                                        style={{transform: planMode?`rotate(${nowYaw-markerConfig[imgIndex].adjustAngle}deg)`:'rotate(0 deg)',
                                                                visibility: imgIndex===i ? "visible" : "hidden"
                                                                }}
                                                      />
                                                  </PlanMarkerWrapper>
                                                  )})
              }
              {mapBtnConfig.map((data,i)=>
                <OverviewBtn
                  key={i}
                  style={{top:data.planTop, left:data.planLeft}}
                  src={langCh? data.imgCh : data.imgEn }
                  onClick={()=>{
                    setImgIndex(data.args[0])
                    setGoToYaw(data.args[1])
                    setGoToPitch(data.args[2])
                  }}
                />
              )}
          </MapPlanWrapper>
          <CloseButton
            style={{top: scrollXY[0]+5, left: scrollXY[1]+5}}
            handler={closeHandler}
          />
          <ResizeButton
            style={{top: scrollXY[0]+5, left: scrollXY[1]+45}}
            src={planMode === 'med'?resizeExpandIcon:resizeShrinkIcon}
            handler={ ()=> {planMode === 'med' ? setPlanMode('large') : setPlanMode('med')
                    } }
          />
      </MapOuter>
  )
}

const MapOverview=( props )=>{
  
  const { overviewMode, setOverviewMode,setImgIndex, setGoToYaw, setGoToPitch, langCh }=props

  const [ mapOverviewProps, setMapOverviewProps ] = useSpring(()=>({ width:'0vw',height:'0vw',overflow:'hidden'}) )
  
  useEffect(()=>{
    if(overviewMode){
      setMapOverviewProps({ width:'96vw',height:'42.5vw',overflow:'hidden'})
    }else{
      setMapOverviewProps({ width:'0vw',height:'0vw',overflow:'hidden'})
    }
  },[ overviewMode ])
  
  return(
    <MapOuter style={mapOverviewProps}>
      <CloseButton 
        style={{top: '5px', left: '5px'}}
        handler={()=>setOverviewMode(false)}
      />
      <MapPlanWrapper style={{backgroundImage: `url(${overview})`}} >
        {mapBtnConfig.map((data,i)=>
          <OverviewBtn
            key={i}
            style={{top:data.overviewTop, left:data.overviewLeft}}
            src={langCh? data.imgCh : data.imgEn }
            onClick={()=>{
              setImgIndex(data.args[0])
              setGoToYaw(data.args[1])
              setGoToPitch(data.args[2])
            }}
          />
        )}
      </MapPlanWrapper>
    </MapOuter>
  )
}

export { MapOverview, MapPlan }